// extracted by mini-css-extract-plugin
module.exports = {"actionsCell":"actionsCell__Tj7gf"};